// extracted by mini-css-extract-plugin
export var avatarContainer = "_ca-0";
export var avatarTypingWave = "_ca-i";
export var gray = "_ca-f";
export var green = "_ca-c";
export var icon = "_ca-9";
export var image = "_ca-1";
export var lg = "_ca-6";
export var md = "_ca-5";
export var presenceDot = "_ca-b";
export var red = "_ca-d";
export var sm = "_ca-4";
export var status = "_ca-a";
export var typingDot = "_ca-h";
export var typingPill = "_ca-g";
export var xl = "_ca-7";
export var xs = "_ca-3";
export var xxl = "_ca-8";
export var xxs = "_ca-2";
export var yellow = "_ca-e";